<template>
  <div class="knowledge-editor-container">
    <h1 class="page-title">Knowledge Centre</h1>
    <!-- Article Meta: Title and Category -->
    <div class="article-meta"><input type="text" v-model="title" placeholder="Enter article title" class="title-input"/>
      <input type="text" v-model="category" placeholder="Enter article category" class="category-input"/>
    <!-- Save Article Button -->
    <button @click="handleSave" class="save-article-btn">Create Article</button>
    <div v-if="successMessage" class="success-message">
      {{ successMessage }}
    </div>
    <div v-if="error" class="error-message">
      {{ error }}
    </div>
  </div>

    <!-- Knowledge Articles Table -->
    <table class="articles-table">
      <thead>
        <tr>
          <th>Category</th>
          <th>Title</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="article in articles" :key="article.id">
          <td>{{ article.category }}</td>
          <td>{{ article.title }}</td>
          <td>
            <a href="javascript:void(0)" @click="editArticle(article)">Edit</a>
          </td>
          <td>
            <a href="javascript:void(0)" @click="deleteArticle(article)">Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import KnowledgeEditorLogic from "./KnowledgeEditorLogic.js";

export default {
  name: "KnowledgeEditor",
  mixins: [KnowledgeEditorLogic],
  props: {
    initialArticleId: {
      type: String,
      default: null
    }
  },
  methods: {
    async handleSave() {
      // Since we're not using EditorJS on this page, clear description
      this.description = "";
      await this.saveArticle();
      // After saving, redirect to the dedicated Article Editor page
      this.$router.push(`/knowledge-editor/edit/${this.localArticleId}`);
    }
  }
};
</script>

<style scoped>
.knowledge-editor-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 12px;
  font-family: "Poppins", sans-serif;
  color: #111827;
}

.page-title {
  font-size: 30px;
  font-weight: 600;
  margin: 30px 0;
  text-align: center;
}

.article-meta {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.title-input,
.category-input {
  font-family: "Courier Prime", monospace;
    font-weight: 400;
    font-style: normal;
    width: 92%;
    padding: 12px;
    border: 1px solid #C9BF9B;
    box-shadow: inset 0px 3px 2px #dacb9754;
    border-radius: 9px;
    font-size: 14px;
    color: #111827;
    background-color: #fff;
}

.save-article-btn {
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    background-color: #EA845A;
    border: 1px solid #C06C4A;
    box-shadow: inset 0px 2px 3px 0px #FFB681, 0px 2px 3px 0px #FFB681;
    border-radius: 15px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: block;
    margin: 0 auto;
    width: 40%;
}

.save-article-btn:hover {
  background-color: rgb(255, 141, 92);
}

.success-message {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 1rem;
  text-align: center;
  margin-top: 1rem;
}

.error-message {
  color: #dc2626;
  font-size: 1rem;
  text-align: center;
  margin-top: 1rem;
}

.articles-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 2rem;
  text-align: center;
}

.articles-table {
    width: 100%;
    margin-bottom: 30px;
    border-collapse: separate;
    border-spacing: 0;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #dacb9736;
}

.articles-table th,
.articles-table td {
  padding: 0.75rem;
  text-align: left;
}

.articles-table th {
  background-color: #f3f1eb;
  font-weight: 600;
}

.articles-table a {
  color: #EA845A;
  text-decoration: none;
}

.articles-table a:hover {
  text-decoration: underline;
}
</style>
